import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { Product } from '@/modules/products'
import { MOCK_PRODUCTS } from '@/modules/products/config/mock-data'

interface ProductsState {
  products: Product[]
  initialized: boolean
  add: (p: Product) => void
  update: (id: string, patch: Partial<Product>) => void
  remove: (id: string) => void
  reset: () => void
  getById: (id: string) => Product | undefined
  getBySlug: (slug: string) => Product | undefined
}

export const useAdminProductsStore = create<ProductsState>()(
  persist(
    (set, get) => ({
      products: MOCK_PRODUCTS.slice(),
      initialized: true,
      add: (p) => set({ products: [p, ...get().products] }),
      update: (id, patch) => set({
        products: get().products.map((x) => (x.id === id ? { ...x, ...patch } : x)),
      }),
      remove: (id) => set({ products: get().products.filter((x) => x.id !== id) }),
      reset: () => set({ products: MOCK_PRODUCTS.slice() }),
      getById:   (id)   => get().products.find((x) => x.id === id),
      getBySlug: (slug) => get().products.find((x) => x.slug === slug),
    }),
    {
      name: 'xedien.admin.products.v1',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ products: s.products }),
    },
  ),
)
